import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "m-view-tx" }
const _hoisted_2 = { class: "tx-area table-shadow" }
const _hoisted_3 = { class: "line flex-left" }
const _hoisted_4 = { class: "line flex-left" }

import { watch, computed } from "vue";
import { filterHash } from "@/utils/filters";
import HomeMixins from "@/mixins/home";
import Count from "@/components/common/Count.vue";
import Store from "@/store/index";


export default /*@__PURE__*/_defineComponent({
  __name: 'TxArea',
  setup(__props) {

const { txLists, getTxList } = HomeMixins();
const maxHeight = computed(() => Store.state.maxHeight);

watch(
  maxHeight,
  () => {
    getTxList();
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "最新数据", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(txLists).list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "tx-item",
          key: index
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", null, [
              _cache[0] || (_cache[0] = _createTextVNode(" 上链哈希： ")),
              _createVNode(_component_router_link, {
                to: { path: '/tradeHash', query: { hash: item.hash } },
                class: "light hash txhash"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(filterHash)(item.hash, 8)), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("p", null, [
              _cache[1] || (_cache[1] = _createTextVNode(" 时间： ")),
              _createVNode(Count, {
                time: item.block_time,
                class: "grey"
              }, null, 8, ["time"])
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", null, [
              _cache[2] || (_cache[2] = _createTextVNode(" 发送方： ")),
              _createVNode(_component_router_link, {
                to: { path: '/address', query: { address: item.from } },
                class: "light hash"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(filterHash)(item.from, 8)), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _createElementVNode("p", null, [
              _cache[3] || (_cache[3] = _createTextVNode(" 接收方： ")),
              _createVNode(_component_router_link, {
                to: { path: '/address', query: { address: item.to } },
                class: "light hash"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(filterHash)(item.to, 8)), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ]))
      }), 128)),
      _createVNode(_component_router_link, {
        to: "/tradelist",
        class: "viewall-btn flex-center"
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode("查看全部")
        ])),
        _: 1
      })
    ])
  ]))
}
}

})